import { loadFullSizeImage } from './helpers';

const $singleMusician = $('.single-musician');

if ($singleMusician.length !== 0) {
	$singleMusician.each(function() {
		const $this = $(this);
		const $image = $this.find('.single-musician__image');
		loadFullSizeImage({
			img: $image,
			classNames: ['single-musician__image'],
		})
			.then(() => {
				$this.find('.single-musician__image').addClass('single-musician__image--show');
			});
	});
}